
import {BTTrackerBase} from './base';

export class OutbrainTracker extends BTTrackerBase {
  configure({outbrain: {tag, testMode, ...restOutbrain} = {}, ...restParams}) {
    super.configure({outbrain: {tag, testMode, ...restOutbrain}, ...restParams});

    this.tag = tag;
    this.testMode = testMode;
  }

  getName() {
    return 'OutbrainTracker';
  }

  get requiresTrackingConsent() {
    return true;
  }

  get restrictsEventsWithoutConsent() {
    return true;
  }

  init(...params) {
    if (!this.canInitialize()) {
      return false;
    }

    if (!this.tag) {
      this.log('Outbrain disabled because no tag was specified.');
      this.disable();
      return false;
    }

    this.loadTag();

    super.init(...params);

    this.log('Outbrain initialized', {tag: this.tag, testMode: this.testMode});

    return true;
  }

  loadTag() {
    /* eslint-disable */
    (function (_window, _document, t) {
      const OB_ADV_ID = t;
      if (_window.obApi) {
        const toArray = function (object) { return Object.prototype.toString.call(object) === '[object Array]' ? object : [object]; };
        _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID)); return;
      }
      var api = _window.obApi = function () { api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments); };
      api.version = '1.1'; api.loaded = true; api.marketerId = OB_ADV_ID; api.queue = []; const tag = _document.createElement('script'); tag.async = true; tag.src = '//amplify.outbrain.com/cp/obtp.js'; tag.type = 'text/javascript'; const script = _document.getElementsByTagName('script')[0]; script.parentNode.insertBefore(tag, script);
    }).call(this, window, document, this.tag);
    /* eslint-enable */
  }

  purchase(order, items, {addon} = {}) {
    if (!super.purchase(order, items, {addon})) {
      return false;
    }

    if (addon) {
      this.log('Outbrain purchase event will not fire for an add-on to an existing order.', {order, items, addon});
      return false;
    }

    if (!order) {
      this.log('Outbrain purchase event will not fire when no order information provided.');
      return false;
    }

    this.log(order, items, addon);

    if (this.testMode) {
      window.obApi('track', 'Test Pixel');
    } else {
      window.obApi('track', 'Store Buyers');
      window.obApi('track', 'Purchase', {orderValue: (order.subtotal + order.shipping).toFixed(2), currency: 'USD'});
    }

    this.log('Outbrain purchase event fired.', {order, testMode: this.testMode, orderValue: order.total});

    return true;
  }

  view() {
    if (!super.view()) {
      return false;
    }

    window.obApi('track', 'PAGE_VIEW');
    this.log('Outbrain page view event fired.');
    return true;
  }
}
